export default {
    list: {
        title: 'Destinatarios',
        subtitle: 'Gestiona tus colaboraciones con destinatarios',
        invite: 'Invitar Destinatario',
        loading: 'Cargando destinatarios...',
        searchPlaceholder: 'Buscar por nombre o email...',
        statusPlaceholder: 'Filtrar por estado',
        countryPlaceholder: 'Filtrar por país',
        description: 'Lista de destinatarios con los que colaboras',
        headers: {
            company: 'Empresa',
            country: 'País',
            email: 'Email',
            status: 'Estado',
            activeContainers: 'Contenedores Activos',
            totalContainers: 'Total de Contenedores',
            lastContainer: 'Último Contenedor',
            inviteDate: 'Fecha de Invitación',
            actions: 'Acciones',
        },
        noReceivers: {
            title: 'No se encontraron destinatarios',
            message: 'Intenta modificar los filtros de búsqueda',
            emptyMessage: 'Comienza invitando tu primer destinatario',
            inviteFirst: 'Invitar Primer Destinatario',
        },
        modal: {
            title: 'Invitar Destinatario',
            selectReceiver: 'Seleccionar Destinatario',
            selectReceiverPlaceholder: 'Elige un destinatario...',
            notes: 'Notas (opcional)',
            notesPlaceholder: 'Añade una nota para el destinatario...',
            selectedReceiver: 'Destinatario Seleccionado',
            name: 'Nombre',
            email: 'Email',
            country: 'País',
            cancel: 'Cancelar',
            sendInvite: 'Enviar Invitación',
            mode: {
                email: 'Email Manual',
                addressBook: 'Libreta de Direcciones',
            },
            emailLabel: 'Dirección de Email',
            emailPlaceholder: 'Ingresa la dirección de email del destinatario',
            emailHint: 'El destinatario se añadirá al sistema cuando acepte la invitación',
            selectFromAddressBook: 'Seleccionar de la Libreta de Direcciones',
            selectAddressBookPlaceholder: 'Elige un contacto de la libreta de direcciones...',
            selectedInfo: 'Información Seleccionada',
            role: 'Rol',
        },
        actions: {
            viewDetails: 'Ver Detalles',
            suspend: 'Suspender Colaboración',
            delete: 'Eliminar Colaboración',
        },
        confirmSuspend: '¿Estás seguro de que quieres suspender esta colaboración?',
        confirmDelete: '¿Estás seguro de que quieres eliminar esta colaboración?',
        none: 'Ninguno',
        allStatuses: 'Todos los estados',
        allCountries: 'Todos los países',
    },
    detail: {
        loading: 'Cargando detalles del destinatario...',
        backToList: 'Volver a la Lista',
        notFound: {
            title: 'Destinatario no encontrado',
            message: 'El destinatario seleccionado no existe.',
        },
        info: {
            companyInfo: 'Información de la Empresa',
            containerStats: 'Estadísticas de Contenedores',
            fields: {
                legalName: 'Nombre Legal',
                entityType: 'Tipo de Entidad',
                taxId: 'ID Fiscal',
                country: 'País',
                address: 'Dirección',
                email: 'Email',
                phone: 'Teléfono',
                eta: 'ETA',
            },
            stats: {
                total: 'Total',
                inTransit: 'En Tránsito',
                delivered: 'Entregados',
                delayed: 'Retrasados',
                pendingDocuments: 'Documentos Pendientes',
                highRisk: 'Alto Riesgo',
            },
        },
        containers: {
            title: 'Contenedores',
            count: 'de',
            searchPlaceholder: 'Buscar contenedores...',
            statusPlaceholder: 'Filtrar por estado',
            riskPlaceholder: 'Filtrar por riesgo',
            documentsPlaceholder: 'Filtrar por documentos',
            headers: {
                containerId: 'ID de Contenedor',
                route: 'Ruta',
                progress: 'Progreso',
                eta: 'ETA',
                status: 'Estado',
                docStatus: 'Estado de Documentos',
                riskLevel: 'Nivel de Riesgo',
                value: 'Valor',
                actions: 'Acciones',
            },
            noContainers: {
                title: 'No se encontraron contenedores',
                message: 'Intenta modificar los filtros de búsqueda',
                emptyMessage: 'No hay contenedores para este destinatario',
            },
        },
    },
};

